/** Everyday settlement furnishings. Frames are bottom-centered scenery bounds;
 * none of these templates adds collision, services or travel destinations.
 * The existing dock kind carries low timber/harbor furniture, signs carry civic
 * boards, and village_well carries the well through the same texture pipeline.
 */
export const SETTLEMENT_PROP_TEMPLATES = {
  quayside_bench: { kind: 'dock', name: 'Quayside timber bench', frame: { w: 112, h: 72 }, band: 'vegetation',
    supportSurfaces: [{ x: 8, y: 42, width: 96, height: 7 }] },
  flower_planter: { kind: 'dock', name: 'Flower-filled timber planter', frame: { w: 84, h: 76 }, band: 'vegetation' },
  notice_board: { kind: 'sign', name: 'Sheltered town notice board', frame: { w: 112, h: 140 }, band: 'vegetation' },
  ferry_waymarker: { kind: 'sign', name: 'Ferry and town waymarker', frame: { w: 88, h: 128 }, band: 'vegetation' },
  supply_handcart: { kind: 'dock', name: 'Provisioner’s handcart', frame: { w: 156, h: 104 }, band: 'vegetation' },
  net_drying_rack: { kind: 'dock', name: 'Fishing net drying rack', frame: { w: 152, h: 136 }, band: 'vegetation' },
  provision_barrels: { kind: 'dock', name: 'Stacked provision barrels', frame: { w: 112, h: 88 }, band: 'vegetation' },
  rope_well: { kind: 'village_well', name: 'Canopied rope well', frame: { w: 128, h: 168 }, band: 'vegetation' },
} as const;

export type SettlementPropTemplate = keyof typeof SETTLEMENT_PROP_TEMPLATES;

/** Copy into a prop's palette or spread into a future town's authoring recipe.
 * Runtime maps continue to contain explicit RGB values, not a new theme lookup.
 */
export const SETTLEMENT_PROP_PALETTES = {
  harbor: { primary: '#a37a58', shade: '#64513f', roof: '#354b5b', roofEdge: '#8da7ae',
    wood: '#463d39', woodEdge: '#ae9270', stone: '#7a8186', iron: '#313f49', glass: '#dba46b', glassCore: '#ffe0a0' },
  woodland: { primary: '#69866c', shade: '#425a48', roof: '#515e40', roofEdge: '#a8b387',
    wood: '#4d3c32', woodEdge: '#b59b70', stone: '#89917b', iron: '#3b4740', glass: '#d49b76', glassCore: '#ffdf9b' },
  frost: { primary: '#849ca8', shade: '#506875', roof: '#34465b', roofEdge: '#bbd4da',
    wood: '#51484a', woodEdge: '#bda68d', stone: '#97a6b1', iron: '#364451', glass: '#b98eaa', glassCore: '#ffe5b0' },
} as const;

/** Layer over a theme for planted greenery; timber still uses wood/woodEdge. */
export const SETTLEMENT_FOLIAGE_PALETTES = {
  harbor: { primary: '#63896f', shade: '#3b5b49' },
  woodland: { primary: '#7c9b66', shade: '#48633f' },
  frost: { primary: '#6d9691', shade: '#405e60' },
} as const;
